import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Filters = Partial<{
  invoiceNumber: string;
  companyIds: string[];
  productIds: string[];
  agDateStart: string;
  agDateEnd: string;
}>

type State = {
  filters: Filters;
  reportColumns: string[];
};

type Actions = {
  updateFilters: (filters: Filters) => void;
  updateReportColumns: (reportColumns: string[]) => void;
  clearState: () => void;
};

const getInitialState = () => ({
  filters: {},
  reportColumns: [],
});

export const usePendingStocksSearchParams = create(
  persist<State & Actions>(
    (set, get) => ({
      ...getInitialState(),
      updateFilters: (filters) => set({ filters }),
      updateReportColumns: (reportColumns) => set({ reportColumns }),
      clearState: () => set(getInitialState()),
    }),
    {
      name: 'pending-stocks-search-params-v1',
      // @ts-ignore
      partialize: (state) => ({
        reportColumns: state.reportColumns,
      }),
    }
  )
);